import { useEffect, useState } from "react";
import { wpPageMap } from "./wp-page-map";
import { AdminLayout } from "@autoserve/woosent.woosent.admin-layout";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

function App() {
	// @ts-ignore
	const { version, isValidAccount } = window.adminUiAppContext || {};

	const [currentPageTitle, setCurrentPageTitle] = useState("");
	const [currentPage, setCurrentPage] = useState<JSX.Element | null>(null);
	const [currentLayoutSetting, setCurrentLayoutSetting] = useState(false);

	const navigateReactWithWpPage = () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const pageParam = urlSearchParams.get("page");
		const routes = Object.keys(wpPageMap);

		if (routes.includes(pageParam as string)) {
			const screen = wpPageMap[pageParam as string];
			const { pageTitle, page, layoutFixed } = screen;

			setCurrentPageTitle(pageTitle);
			setCurrentPage(page);
			setCurrentLayoutSetting(layoutFixed);
		}
	};

	// useEffect hook to navigate between pages
	useEffect(() => {
		navigateReactWithWpPage();

		// @ts-ignore
		window.reactAppControllers = {
			_navigate: navigateReactWithWpPage,
		};
	}, []);

	return (
		<AdminLayout
			version={version}
			pageTitle={currentPageTitle}
			fixedFooter={currentLayoutSetting}>
			{!isValidAccount && (
				<Alert severity='error' sx={{ my: 2 }}>
					<AlertTitle>Important</AlertTitle>
					Your account is not in good standing. Please check your MessageFlow
					account for any unfulfilled payments.{" "}
					<a href='https://app.messageflow.co' target='_blank' rel='noreferrer'>
						Log in
					</a>
				</Alert>
			)}
			{currentPage}
		</AdminLayout>
	);
}

export default App;
